import { ClientCollection } from "../clientCollection.js";
class AbstractPostCollection extends ClientCollection {
}
export { AbstractPostCollection };
